import service from '.';

/** 后端返回的文件选择规则，大小单位统一为字节。 */
export interface ArticleImportRules {
  supportedExtensions: string[];
  maxFileSizeBytes: number;
  maxFileCount: number;
}
/** 清单中的不可变文件身份。 */
export interface ArticleImportFile {
  fileId: string;
  filename: string;
  size: number;
  sha256: string;
}
/** 原始文件只保存在当前组件内存中。 */
export interface SelectedArticleImportFile extends ArticleImportFile {
  file: File;
}
/** 首次提交和失败项重试使用同一批次清单，每次生成新的 batchId。 */
export interface ArticleImportManifest {
  batchId: string;
  companyId: string;
  files: ArticleImportFile[];
}
/** 成功文件的已确认文章数量，用于按 fileId 替换后重新汇总。 */
export interface ArticleImportSuccess {
  fileId: string;
  filename: string;
  importedArticleCount: number;
  skippedArticleCount: number;
}
/** 明确失败或待核实文件的安全展示信息。 */
export interface ArticleImportFailure {
  fileId: string;
  filename: string;
  errorCode: string;
  errorMessage: string;
}
/** 明确失败项只有服务端允许时才可重试。 */
export interface ArticleImportFailedFile extends ArticleImportFailure {
  retryable: boolean;
}
/** 成功文件的非阻断提示。 */
export interface ArticleImportWarning {
  fileId: string;
  filename: string;
  warningCode: string;
  warningMessage: string;
}
/** 同步处理全部文件后直接返回的完整最终结果，不包含轮询协议字段。 */
export interface ArticleImportResult {
  batchId: string;
  importedArticleCount: number;
  skippedArticleCount: number;
  failedFileCount: number;
  retryableFileCount: number;
  unknownFileCount: number;
  successfulFiles: ArticleImportSuccess[];
  failedFiles: ArticleImportFailedFile[];
  warningFiles: ArticleImportWarning[];
  unknownFiles: ArticleImportFailure[];
}

/** CRM Cookie 鉴权下的文章同步整批导入接口。 */
export const articleImportApi = {
  /**
   * 查询有效文件选择规则。
   * @returns {Promise<ArticleImportRules>} 后端文件类型、大小及数量限制。
   */
  getRules(): Promise<ArticleImportRules> {
    return service.get('/company/article/upload/rules', { isSilence: true });
  },
  /**
   * 一次提交本批全部文件并等待最终结果，沿用统一业务响应解包且不自动重传。
   * @param {FormData} body JSON 清单及对应文件二进制。
   * @returns {Promise<ArticleImportResult>} 全部文件处理完毕的最终结果。
   */
  submit(body: FormData): Promise<ArticleImportResult> {
    return service.post('/company/article/upload/batches', body, { isSilence: true });
  },
};
